import React, { useEffect, useState } from 'react';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import InputSelect from '../../../../component/inputSelect/InputSelect';
import { getCurrentDate } from '../../../../utils/dateUtils';
import { capitalizeWords, generateArray, reportNamefilter } from '../../../../utils/constant';
import {
	getOrgReceipientEmails,
	getScheduled,
	scheduledReport,
	updateScheduledReport,
} from '../../../../services/reports';
import { toast } from 'react-toastify';
import { format, parseISO } from 'date-fns';
import Button from '../../../../component/ui/Button';

export default function ScheduleReportModal({
	id,
	isScheduleModelOpen,
	setIsScheduleModelOpen,
	activeTab,
}) {
	const [error, setError] = useState({});
	const [loader, setLoader] = useState(false);
	const [isReceipientEmailLoader, setIsReceipientEmailLoader] = useState(false);
	const [reciepientEmailsList, setReciepientEmailsList] = useState([]);
	const [scheduleParams, setScheduleParams] = useState({
		frequency: '',
		start_date: getCurrentDate(),
		hour: '',
		minute: '',
		status: 'active',
		primary_email: '',
		additional_recipients: '',
		clock_type: '',
		file_format: 'pdf',
	});

	const frequencyList = [
		{ key: 'Weekly', value: 'Weekly' },
		{ key: 'Monthly', value: 'Monthly' },
		{ key: 'Yearly', value: 'Yearly' },
	];
	const gethourList = generateArray(24);
	const getminuteList = generateArray(60);
	const clockTypeList = [
		{ key: 'AM', value: 'AM' },
		{ key: 'PM', value: 'PM' },
	];

	const checkValidation = () => {
		let newError = { ...error };

		if (
			!scheduleParams.frequency ||
			scheduleParams.frequency === '' ||
			scheduleParams.frequency === null ||
			scheduleParams.frequency === undefined
		) {
			newError.frequency = 'Pkease select frequency name in the list';
		} else {
			delete newError.frequency;
		}
		if (
			!scheduleParams.start_date ||
			scheduleParams.start_date === '' ||
			scheduleParams.start_date === null ||
			scheduleParams.start_date === undefined
		) {
			newError.start_date = 'Pkease enter start date in the field';
		} else {
			delete newError.start_date;
		}
		if (
			!scheduleParams.hour ||
			scheduleParams.hour === '' ||
			scheduleParams.hour === null ||
			scheduleParams.hour === undefined
		) {
			newError.hour = 'Pkease select hour in the list';
		} else {
			delete newError.hour;
		}
		if (
			!scheduleParams.minute ||
			scheduleParams.minute === '' ||
			scheduleParams.minute === null ||
			scheduleParams.minute === undefined
		) {
			newError.minute = 'Pkease select minute in the list';
		} else {
			delete newError.minute;
		}
		if (
			!scheduleParams.clock_type ||
			scheduleParams.clock_type === '' ||
			scheduleParams.clock_type === null ||
			scheduleParams.clock_type === undefined
		) {
			newError.clock_type = 'Pkease select minute in the list';
		} else {
			delete newError.clock_type;
		}

		if (
			!scheduleParams.primary_email ||
			scheduleParams.primary_email === '' ||
			scheduleParams.primary_email === null ||
			scheduleParams.primary_email === undefined
		) {
			newError.primary_email = 'Pkease select email reciepents in the list';
		} else {
			delete newError.primary_email;
		}
		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	};

	const handleSaveScheduleReport = async () => {
		const isError = checkValidation();
		if (isError) {
			toast.error('Please filled all required fields in report schedule');
			return;
		} else {
			try {
				setLoader(true);
				const body = {
					...scheduleParams,
					additional_recipients: scheduleParams.additional_recipients
						? scheduleParams.additional_recipients.split(',').map((e) => e.trim())
						: [],
					report_name: activeTab.toLowerCase().replaceAll(' ', '_'),
				};
				let res;
				if (id) {
					res = await updateScheduledReport(id, body);
				} else {
					res = await scheduledReport(body);
				}
				if (res.success) {
					toast.success(res.message);
					setIsScheduleModelOpen(false);
				} else {
					toast.error(res.message);
				}
			} catch (error) {
			} finally {
				setLoader(false);
			}
		}
	};

	const handleFormData = (key, value, inputType, required = false) => {
		setScheduleParams((prev) => ({
			...prev,
			[key]: value,
		}));
		let newError = { ...error };
		if (required) {
			if (value !== '' && value !== undefined && value !== null) {
				delete newError[key];
			} else {
				newError[key] =
					inputType === 'field'
						? `Please enter ${key.replaceAll('_', ' ')} in the field.`
						: `Please select a valid ${key.replaceAll('_', ' ')} from the list.`;
			}
		}
		setError(newError);
	};

	const getReceipientEmails = async () => {
		try {
			setIsReceipientEmailLoader(true);
			const { users } = await getOrgReceipientEmails();
			if (users.length > 0) {
				const data = users.map((item) => {
					return {
						key: item.email || '',
						value: item.name || '',
					};
				});
				setReciepientEmailsList(data);
			}
		} catch (error) {
		} finally {
			setIsReceipientEmailLoader(false);
		}
	};

	const getScheduleDetails = async () => {
		try {
			const { scheduled_report } = await getScheduled(id);
			if (scheduled_report) {
				setScheduleParams({
					frequency: capitalizeWords(scheduled_report.frequency),
					status: scheduled_report.status,
					clock_type: scheduled_report.clock_type,
					start_date:
						scheduled_report.start_date !== null && scheduled_report.start_date !== ''
							? format(parseISO(scheduled_report.start_date), 'yyyy-MM-dd')
							: '',
					hour: scheduled_report.hour || '',
					minute: scheduled_report.minute || '',
					primary_email: scheduled_report.primary_email || '',
					additional_recipients:
						scheduled_report.additional_recipients.length > 0
							? scheduled_report.additional_recipients.join(', ')
							: '',
					file_format: scheduled_report.file_format,
				});
			}
		} catch (error) {}
	};

	useEffect(() => {
		getScheduleDetails();
	}, [id]);

	useEffect(() => {
		getReceipientEmails();
	}, []);

	return (
		<div>
			<Modal
				className="schedule-report-modal"
				title={`Schedule Report`}
				isOpen={isScheduleModelOpen}
				actionButton={
					loader || (id && scheduleParams.status === 'paused') ? null : isScheduleModelOpen
				}
				handleSave={() => {
					handleSaveScheduleReport();
				}}
				onClose={() => {
					setIsScheduleModelOpen(false);
				}}
				cancelButton={() => {
					setIsScheduleModelOpen(false);
				}}
			>
				<div>
					<div className="d-flex gap-2 align-items-center">
						Report Name : <b>{activeTab}</b>
					</div>
					<div className="d-flex align-items-center gap-4 py-3">
						<div className="col-3">
							<InputSelect
								options={frequencyList}
								label="Frequency"
								placeholder="Frequency"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.frequency}
								onChange={(value) => {
									if (value === '') {
										handleFormData('frequency', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('frequency', option.key, 'select', true)}
								error={error?.frequency}
							/>
						</div>
						<div
							className="fs-4 fw-light"
							style={{ paddingTop: '15px' }}
						>
							Report will be generated and sent on a weekly basis.
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<InputField
								label="Start Date"
								placeholder="Enter Date"
								type="date"
								autoComplete="off"
								required={true}
								error={error?.start_date}
								// autoFocus={isDateFocus}
								value={scheduleParams.start_date}
								onChange={(value) => handleFormData('start_date', value, 'field', true)}
							/>
						</div>
						<div className="col-2">
							<InputSelect
								options={gethourList}
								label="Hour"
								placeholder="hour"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.hour}
								onChange={(value) => {
									if (value === '') {
										handleFormData('hour', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('hour', option.key, 'select', true)}
								error={error?.hour}
							/>
						</div>
						<div className="col-2">
							<InputSelect
								options={getminuteList}
								label="Minute"
								placeholder="minute"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.minute}
								onChange={(value) => {
									if (value === '') {
										handleFormData('minute', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('minute', option.key, 'select', true)}
								error={error?.minute}
							/>
						</div>
						<div className="col-2">
							<InputSelect
								options={clockTypeList}
								label="AM/PM"
								placeholder="Select"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.clock_type}
								onChange={(value) => {
									if (value === '') {
										handleFormData('clock_type', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('clock_type', option.key, 'select', true)}
								error={error?.clock_type}
							/>
						</div>
					</div>
					{!isReceipientEmailLoader && (
						<div className="fs-3 fw-bold text-dark">Receipient Details</div>
					)}
					{!isReceipientEmailLoader && (
						<div className="col-5 py-3">
							<InputSelect
								options={reciepientEmailsList}
								label="Email Reciepient"
								placeholder="Email Reciepient"
								required={true}
								autoComplete="off"
								disabled={false}
								returnInputValue={false}
								value={scheduleParams.primary_email}
								onChange={(value) => {
									if (value === '') {
										handleFormData('primary_email', value, 'select', true);
									}
								}}
								onSelect={(option) => handleFormData('primary_email', option.key, 'select', true)}
								error={error?.primary_email}
								onAddNew={() => {}}
							/>
						</div>
					)}
					<InputField
						type="text"
						value={scheduleParams?.additional_recipients}
						placeholder=""
						label="Additional Reciepent"
						multiline={true}
						rows={3}
						onChange={(value) => handleFormData('additional_recipients', value, 'field')}
						autoComplete="new-customer-notes"
					/>
					<div className="fs-5 fw-light">Use comma(,) to separate more than one email address.</div>
					<div className="d-flex py-3">
						<div className="fs-4 fw-light py-2">Attach Report As</div>
						<div className="fs-4 fw-light text-danger">*</div>
					</div>
					<div className="d-flex gap-4 align-items-center py-2">
						<label className="d-flex gap-3 py-2 cursor-pointer">
							<input
								type="radio"
								className="custom-radio"
								name="pdf"
								checked={scheduleParams.file_format === 'pdf'}
								onChange={(e) => {
									setScheduleParams((prev) => ({
										...prev,
										file_format: e.target.checked ? 'pdf' : '',
									}));
								}}
							/>
							PDF
						</label>
						<label className="d-flex gap-3 cursor-pointer">
							<input
								type="radio"
								name="csv"
								className="custom-radio"
								checked={scheduleParams.file_format === 'csv'}
								onChange={(e) => {
									setScheduleParams((prev) => ({
										...prev,
										file_format: e.target.checked ? 'csv' : '',
									}));
								}}
							/>
							CSV (Comma Separated Value)
						</label>
						<label className="d-flex gap-3 py-2 cursor-pointer">
							<input
								type="radio"
								name="xls"
								className="custom-radio"
								checked={scheduleParams.file_format === 'xls'}
								onChange={(e) => {
									setScheduleParams((prev) => ({
										...prev,
										file_format: e.target.checked ? 'xls' : '',
									}));
								}}
							/>
							XLS (Microsoft Excel 1997-2004 Compatible)
						</label>
					</div>
					<div className="d-flex gap-2 align-items-center py-4">
						<b>Notes:</b> The Generated report will contain only a maximum of 2000 records
					</div>
				</div>
				{id && scheduleParams.status === 'paused' && (
					<div className="d-flex align-items-center justify-content-end my-4 gap-4">
						<Button
							type="button"
							button={`Cancel`}
							className="mt-0 px-4 btn-gray relative"
							onClick={() => {
								setIsScheduleModelOpen(false);
							}}
						/>
						<Button
							type="button"
							button={`Resume`}
							loader={loader}
							disabled={loader}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => handleSaveScheduleReport()}
						/>
					</div>
				)}
			</Modal>
		</div>
	);
}
